export default class AlertClass {
  constructor(rawdata, type) {
    if (typeof rawdata === "object") this.construct_from_object(rawdata);
    else this.construct_from_params(rawdata, type);
  }

  construct_from_object(rawdata = {}) {
    this.message = rawdata.message ? rawdata.message : "";
    this.type = rawdata.type ? rawdata.type : "error";
    this.status = rawdata.status ? rawdata.status : false;
    this.id = Math.random()
      .toString(36)
      .slice(-8);
  }

  construct_from_params(message, type) {
    this.message = message ? message : "";
    this.type = type ? type : "error";
    this.status = false;
    this.id = Math.random()
      .toString(36)
      .slice(-8);
  }
}
